"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonNavigationLink = void 0;
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const BronsonNavigationLink = (props) => {
    const normalizedPath = props.route.path.replace('/', '');
    return (React.createElement("li", { title: `Ir a ${props.route.label}`, key: `nav-bar-to-${normalizedPath}`, id: `nav-bar-to-${normalizedPath}`, className: 'c-page-head-nav__item c-page-head-nav__item--left u-hide@s' },
        React.createElement(react_router_dom_1.Link, { to: props.route.path, className: 'c-page-head-nav__link router-link-active' },
            React.createElement("span", { className: 'c-page-head-nav__link-text' }, props.route.label || ''))));
};
exports.BronsonNavigationLink = BronsonNavigationLink;
